import { RouteRecordRaw } from 'vue-router';

export const carrierRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'carrier-layout',
    component: () => import('@/layouts/CarrierLayout.vue'),
    meta: {
      requiresAuth: true,
      tenant_type: ['carrier'],
    },
    children: [
      {
        path: '',
        name: 'default-carrier',
        redirect: '/dashboard',
      },
      {
        path: 'drivers',
        name: 'drivers',
        component: () => import('@/pages/drivers/DriversPage.vue'),
        meta: {
          title: 'Drivers',
          entityType: 'driver',
        },
      },
      {
        path: 'mobile-devices',
        name: 'mobile-devices',
        component: () => import('@/pages/mobile-devices/MobileDevicesPage.vue'),
        meta: { title: 'Mobile Devices' },
      },
      {
        path: 'shunters',
        name: 'shunters',
        component: () => import('@/pages/drivers/DriversPage.vue'),
        meta: {
          title: 'Shunters',
          entityType: 'shunter',
        },
      },
      {
        path: 'drivers/calendar-overview',
        name: 'calendar-overview',
        component: () => import('@/pages/drivers/components/CalendarOverview.vue'),
        meta: {
          title: 'Holidays',
        },
      },
      {
        path: 'drivers/start-departure',
        name: 'start-departure',
        component: () => import('@/pages/drivers/components/StartDepartureReport.vue'),
        meta: {
          title: 'Start & Departure',
        },
      },
      {
        path: 'driver/:id',
        name: 'driver',
        component: () => import('@/pages/drivers/DriverDetailPage.vue'),
        meta: {
          title: 'Driver Detail',
          entityType: 'driver',
        },
      },
      {
        path: 'shunter/:id',
        name: 'shunter',
        component: () => import('@/pages/drivers/DriverDetailPage.vue'),
        meta: {
          title: 'Shunter Detail',
          entityType: 'shunter',
        },
      },
      {
        path: 'driver-compliance',
        name: 'driver-compliance',
        component: () => import('@/pages/driver-compliance/DriverCompliancePage.vue'),
        meta: {
          title: 'Driver Compliance',
        },
      },
      {
        path: 'partners',
        name: 'partners',
        component: () => import('@/pages/partners/PartnersPage.vue'),
        meta: {
          title: 'Partners',
        },
      },
      {
        path: 'partner/:id',
        name: 'partner',
        component: () => import('@/pages/partners/PartnersDetailPage.vue'),
        meta: {
          title: 'Partner Detail',
        },
      },
      {
        path: 'fleet',
        name: 'fleet',
        component: () => import('@/pages/fleet/FleetPage.vue'),
        meta: {
          title: 'Fleet',
        },
      },
      {
        path: 'tasks',
        name: 'tasks',
        component: () => import('@/pages/tasks/TasksPage.vue'),
        meta: {
          title: 'Tasks',
        },
      },
      {
        path: 'perceived-loss-fleet',
        name: 'perceived-loss-fleet',
        component: () => import('@/pages/perceived-loss-fleet/PerceivedLossFleetPage.vue'),
        meta: {
          title: 'Perceived Loss Fleet',
        },
      },
      {
        path: 'trailerstands',
        name: 'trailer-stands',
        component: () => import('@/pages/trailer-stands/TrailerStandsPage.vue'),
        meta: {
          title: 'Trailer Stands',
        },
      },
      {
        path: 'fleet/trailer-detail/:id',
        name: 'trailer-detail',
        component: () => import('@/pages/fleet/components/TrailerDetail.vue'),
        meta: {
          title: 'Trailer Detail',
        },
      },
      {
        path: 'fleet/truck-detail/:id',
        name: 'truck-detail',
        component: () => import('@/pages/fleet/components/TruckDetail.vue'),
        meta: {
          title: 'Truck Detail',
        },
      },
      {
        path: 'fleet/templates-editor',
        name: 'templates-editor',
        component: () => import('@/pages/fleet/components/templates-editor/TenantTemplatesEditor.vue'),
        meta: {
          title: 'Templates Manager',
        },
      },
      {
        path: 'fleet/tyres-monitoring',
        name: 'tyres-monitoring',
        component: () => import('@/pages/fleet/TyresMonitoringPage.vue'),
        meta: {
          title: 'Tyres Monitoring',
        },
      },
      {
        path: 'fleet/trucks-assigned',
        name: 'truck-assignments',
        component: () => import('@/pages/fleet/TruckAssignmentsOverviewPage.vue'),
        meta: {
          title: 'Trucks Assigned',
        },
      },
      {
        path: 'fleet/pmi-planner-overview',
        name: 'pmi-planner-overview',
        component: () => import('@/pages/fleet/PmiPlannerOverviewPage.vue'),
        meta: {
          title: 'PMI Planner Overview',
        },
      },
      {
        path: 'check-reports',
        name: 'check-reports',
        component: () => import('@/pages/check-report/CheckReportPage.vue'),
        meta: {
          title: 'Check Reports',
        },
      },
      {
        path: 'shift-reports',
        name: 'shift-reports',
        component: () => import('@/pages/shift-reports/ShiftReportsPage.vue'),
        meta: {
          title: 'Shift Reports',
        },
      },
      {
        path: 'chat-compliance',
        name: 'chat-compliance',
        component: () => import('@/pages/chat-compliance/ChatCompliancePage.vue'),
        meta: {
          title: 'Chat Compliance',
          roles: ['admin', 'tm'],
        },
      },
      {
        path: 'kpi',
        name: 'kpi',
        component: () => import('@/pages/kpi/KpiPage.vue'),
        meta: {
          title: 'KPI',
        },
      },
      {
        path: 'check-entities',
        name: 'check-entities',
        component: () => import('@/pages/check-entity/CheckEntityView.vue'),
        meta: {
          title: 'Check Entities',
        },
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/pages/settings/SettingsPage.vue'),
        meta: {
          title: 'Settings',
          roles: ['admin', 'manger', 'planner'],
        },
      },
      {
        path: 'users',
        component: () => import('@/pages/users/UsersView.vue'),
      },
      {
        path: 'users/calendar-overview',
        component: () => import('@/pages/users/StaffHolidayPage.vue'),
      },
      {
        path: 'users/:id',
        component: () => import('@/pages/users/UserDetailPage.vue'),
      },
      {
        path: 'client-management',
        name: 'client-management',
        component: () => import('@/pages/client-management/ClientManagementPage.vue'),
        meta: {
          title: 'Client Management',
        },
      },
      {
        path: 'goals-projects',
        name: 'goals-projects',
        component: () => import('@/pages/goals-projects/GoalsProjectsPage.vue'),
        meta: {
          title: 'Goals & Projects',
        },
      },
      {
        path: 'chat',
        component: () => import('@/pages/chat/ChatPage.vue'),
      },
      {
        path: 'chat-groups',
        component: () => import('@/pages/chat-groups/ChatGroupsView.vue'),
      },
      {
        path: 'timesheet',
        name: 'timesheet',
        component: () => import('@/pages/timesheet/TimesheetPage.vue'),
        meta: {
          title: 'Timesheet',
        },
      },
      {
        path: 'trips',
        name: 'trips',
        component: () => import('@/pages/trips/TripsView.vue'),
        meta: {
          title: 'Trips',
        },
      },
      {
        path: 'trip-documents/:vrid',
        name: 'trip-documents',
        component: () => import('@/pages/trip-documents/TripDocumentsPage.vue'),
        meta: {
          title: 'Trip Documents',
        },
      },
      {
        path: 'planning',
        name: 'planning',
        component: () => import('@/pages/planning/PlanningPage.vue'),
        meta: {
          title: 'Planning',
        },
      },
      {
        path: 'planning-preview',
        name: 'planning-preview',
        component: () => import('@/pages/planning-preview/PlanningPreviewPage.vue'),
        meta: {
          title: 'Planning Preview',
          roles: ['admin', 'pm'],
          tenants: ['dlg1', 'teoinc'],
        },
      },
      {
        path: 'future-planning',
        name: 'future-planning',
        component: () => import('@/pages/planning/components/FuturePlanningPage.vue'),
        meta: {
          title: 'Future Planning',
        },
      },
      {
        path: 'sites',
        name: 'sites',
        component: () => import('@/pages/sites/SitesPage.vue'),
        meta: {
          title: 'Sites',
        },
      },
      {
        path: 'map-overview',
        name: 'map-overview',
        component: () => import('@/pages/map-overview/MapOverviewPage.vue'),
        meta: {
          title: 'Map Overview',
        },
      },
      {
        path: 'device-tracking',
        name: 'device-tracking',
        component: () => import('@/pages/device-tracking/DeviceTrackingPage.vue'),
        meta: {
          title: 'Device Tracking',
        },
      },
      {
        path: 'reports',
        name: 'reports',
        component: () => import('@/pages/reports/ReportsPage.vue'),
        meta: {
          title: 'Reports',
        },
      },
      {
        path: 'documents',
        name: 'Documents',
        component: () => import('@/pages/documents/DocumentsPage.vue'),
        meta: {
          title: 'Documents',
        },
      },
      {
        path: 'costs',
        name: 'costs',
        component: () => import('@/pages/costs/CostsPage.vue'),
        meta: {
          title: 'Costs',
        },
      },
      {
        path: 'profitability',
        name: 'profitability',
        component: () => import('@/pages/profitability/ProfitabilityPage.vue'),
        meta: {
          title: 'Company Profitability',
        },
      },
      {
        path: 'mechanic-shop',
        name: 'mechanic-shop',
        component: () => import('@/pages/mechanic-shop/MechanicShopInventoryPage.vue'),
        meta: {
          title: 'Mechanic Shop',
        },
      },
      {
        path: 'purchase-orders',
        name: 'purchase-orders',
        component: () => import('@/pages/purchase-orders/PurhcaseOrdersPage.vue'),
        meta: {
          title: 'Purchase Orders',
        },
      },
      {
        path: 'goods-reception',
        name: 'goods-reception',
        component: () => import('@/pages/goods-reception/GoodsReceptionPage.vue'),
        meta: {
          title: 'Goods Reception',
        },
      },
      {
        path: 'subcontractor-invoicing',
        name: 'subcontractor-invoicing',
        component: () => import('@/pages/subcontractor-invoicing/SubcontractorInvoicing.vue'),
        meta: {
          title: 'Subcontractor Invoicing',
        },
      },
      {
        path: 'fuel-cards',
        name: 'fuel-cards',
        component: () => import('@/pages/fuel-cards/FuelCardsView.vue'),
        meta: {
          title: 'Fuel Cards',
        },
      },
      {
        path: 'fuel',
        name: 'fuel',
        component: () => import('@/pages/fuel/FuelView.vue'),
        meta: {
          title: 'Fuel',
        },
      },
      {
        path: 'defect',
        name: 'defect',
        component: () => import('@/pages/defects/DefectView.vue'),
        meta: {
          title: 'Defect',
        },
      },
      {
        path: 'tachograph-files',
        name: 'tachograph-files',
        component: () => import('@/pages/tachograph-files/TachographFilesPage.vue'),
        meta: {
          title: 'Tachograph Files',
        },
      },
      {
        path: 'audit-logs',
        name: 'audit-logs-carrier',
        component: () => import('@/pages/audit-logs/AuditLogsPage.vue'),
        meta: {
          title: 'Audit Logs',
        },
      },
      {
        path: 'seal-checks',
        name: 'seal-checks',
        component: () => import('@/pages/seal-checks/SealChecksView.vue'),
        meta: {
          title: 'Seal Checks',
        },
      },
      {
        path: 'seal-reports',
        name: 'seal-reports',
        component: () => import('@/pages/seal-reports/SealReportsView.vue'),
        meta: {
          title: 'Seal Reports',
        },
      },
      {
        path: 'note',
        name: 'note',
        component: () => import('@/pages/notes/NotePage.vue'),
        meta: {
          title: 'Note',
        },
      },
      {
        path: 'driver-tickets',
        name: 'driver-tickets',
        component: () => import('@/pages/driver-tickets/DriverTicketsPage.vue'),
        meta: {
          title: 'Driver tickets',
        },
      },
      {
        path: 'cases',
        name: 'cases',
        component: () => import('@/pages/cases/CasesPage.vue'),
        meta: {
          title: 'Cases',
        },
      },
      {
        path: 'user-profile',
        name: 'user-profile',
        component: () => import('@/pages/user-profile/UsersProfileView.vue'),
        meta: {
          title: 'User Profile',
        },
      },
      {
        path: 'company-profile',
        name: 'company-profile',
        component: () => import('@/pages/company-profile/CompanyProfilePage.vue'),
        meta: {
          title: 'Company Profile',
        },
      },
      {
        path: 'incidents',
        name: 'incidents',
        component: () => import('@/pages/incidents/IncidentsPage.vue'),
        meta: {
          title: 'Incidents',
        },
      }
      ,
      {
        path: 'goodsreception',
        name: 'goodsreception',
        component: () => import('@/pages/goods-reception/GoodsReceptionPage.vue'),
        meta: {
          title: 'Goods Reception',
        },
      },
      {
        path: 'dashboard',
        name: 'dashboard-cards',
        component: () => import('@/pages/dashboard/CarrierDashboardEntry.vue'),
        meta: {
          title: 'Dashboard cards',
        },
      },
      {
        path: 'fleet-event-dashboard/week',
        name: 'fleet-event-dashboard-week',
        component: () => import('@/pages/fleet-event-dashboard/FleetEventDashboardWeek.vue'),
        meta: {
          title: 'Fleet event dashboard',
        },
      },
      {
        path: 'fleet-event-dashboard/year',
        name: 'fleet-event-dashboard-year',
        component: () => import('@/pages/fleet-event-dashboard/FleetEventDashboardYear.vue'),
        meta: {
          title: 'Fleet event dashboard',
        },
      }
    ],
  },
];
